/**
 * `?run=1` on Advanced (BI) (CU-869fmhmx8 D9): a link from a BI dashboard opens the explorer already searched.
 * Only when the decoded `sp` passes the BI form's schema; otherwise the form is filled and the user presses Search,
 * as before. Without `run=1`, nothing changes.
 *
 * The schema comes as a parameter (it reads signals behind aliases), so `node --test` runs this.
 */
export function shouldAutoRun(params, decoded, schema) {
	if (params?.get?.('run') !== '1') return false
	if (!decoded || typeof decoded !== 'object') return false
	try {
		return !!schema?.isValidSync?.(decoded)
	} catch {
		return false
	}
}
